import "./index.scss";
import React, { useEffect } from "react";
import accessibility from "../../assets/img/peabody-logo-white.png";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { isUndefinedNullOrEmpty } from "../../utils/translation/helper";
type FooterProps = {
  name: string;
};

const Footer: React.FC<FooterProps> = ({ name }) => {
  const { t } = useTranslation();

  const showFooter = useSelector(
    (state: any) => state?.userChoicesReducer?.showFooter
);

useEffect(() => {  
}, [showFooter]);

  const termsLink = () => {
    // Using window.open without "noopener" can be unsafe because the new page can access the window.opener property and potentially manipulate the original page.
    // To ensure safety, always include "noopener" in the window features or use rel="noopener" on anchor tags.
    window.open(
      "https://www.peabody.org.uk/terms-conditions",
      "",
      "noopener,width=auto,height=auto"
    );
  }

  const AccessibilityLink = () => {
    window.open("https://www.peabody.org.uk/accessibility-translations",
      "", "noopener,width=auto, height=auto");
  }
  const privacyLink = () => {
    window.open("https://www.peabody.org.uk/terms-conditions/privacy",
      "", "noopener,width=auto, height=auto");
  }
  const cookiesLink = () => {
    window.open("https://www.peabody.org.uk/terms-conditions/cookies",
      "", "noopener,width=auto, height=auto");
  }
  return (
    <>
      {showFooter && (
        <footer className="footer-main">
          <div className="row">
            <div className="col-md-3 footer-copyright">
              {t("Peabody_2023")}
            </div>
            <div className="col-md-6 list-footer">
                  <ul className="footer-navigation">
                    <li>
                      <a onClick={termsLink} rel="noopener">{t("Terms_And_Conditions")}</a>
                    </li>
                    <li>
                      <a onClick={AccessibilityLink} rel="noopener">{t("Accessibility")}</a>
                    </li>
                    <li>
                      <a onClick={privacyLink} rel="noopener">{t("Privacy")}</a>
                    </li>
                    <li>
                      <a onClick={cookiesLink} rel="noopener">{t("Cookies")}</a>
                    </li>
                  </ul>
            </div>
            <div className="col-md-3 footer-logo-align">
              <img src={accessibility} alt="Peabody Logo - Footer" className="footer-logoimage"></img>
            </div>

          </div>
        </footer>
      )}
    </>
  );
};

export default Footer;
